import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Route, Routes } from 'react-router-dom';
import { Loader } from 'rs-emd-ui-atoms';
import { useGetContextInfoQuery } from '../../../generated/graphql';
import { RedirectWithStatus } from '../../../rs-emd-ui-modules/src/helpers/redirect-with-status.component';
import { PrintAsQuoteWrapper } from '../../basket-purchase/print-as-quote-wrapper-component';
import Master from '../../master/master-component';
import MyAccountPrintOrderDetailsWrapper from '../../user/my-account/my-account-print-order-details-wrapper-component';
import SubscribePageWrapper from '../../user/subscribe-wrapper';
import UnsubscribePageWrapper from '../../user/unsubscribe-wrapper';
import ScrollToTop from './scroll-to-top-component';

export const StyledRouter: FunctionComponent = () => {
  const { loading, error, data } = useGetContextInfoQuery({ ssr: true });

  if (loading || !data) {
    return <Loader />;
  } else if (error || !data) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_ENDPOINT} statusCode={500} />;
  }

  return (
    <>
      <Helmet>
        {/*HTML Lang*/}
        <html className='rs-page' />
      </Helmet>

      <Routes>
        {/* START: Routes without header/footer */}
        <Route path='printQuote' element={<PrintAsQuoteWrapper contextInfo={data?.master.contextInfo} />} />
        <Route
          path='user/myaccount/printOrder/:orderId'
          element={<MyAccountPrintOrderDetailsWrapper contextInfo={data?.master.contextInfo} />}
        />
        <Route path='user/subscribe' element={<SubscribePageWrapper />} />
        <Route path='user/unsubscribe' element={<UnsubscribePageWrapper />} />
        {/* END: Routes without header/footer */}

        <Route
          path='*'
          element={
            <>
              <ScrollToTop />
              <Master contextInfo={data?.master.contextInfo} />
            </>
          }
        />
      </Routes>
    </>
  );
};
